export default __webpack_public_path__ + "static/media/school.536fa102.webp";